// src/websocket/topics.js
export const TOPICS = {
  QUEUE: '/topic/queue-number',
  NOTIFY: '/topic/update-screen-tv',
};